<!--
 * @Desc: 新闻
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-13 08:20:09
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-news">
        <div class="container">
            <section class="info">
                <!-- 新闻 标页码 -->
                <div class="news-pagination">
                    <span
                        class="pagination-bullet"
                        :class="[
                            idx == activeIndex
                                ? 'pagination-bullet-active'
                                : '',
                        ]"
                        v-for="(item, idx) in swiper.slides"
                    ></span>
                </div>
                <div class="title">新闻</div>
                <div class="new-title">关于政府对教育可能意味着的六点思考</div>
                <p class="new-desc">学校以“精细管理、高效课堂、激情教育”为显著特点的管理模式，并在“双减”背景下对此进行科学优化，全面贯彻落实立德树人的根本任务，坚持“明大德、立大志、勤学习、善思考、勇实践、乐创新”和“紧盯别人优点，朝着美的方向生长”的育人理念。</p>
                <div class="btn-more">了解更多<img src="../../../public/statics/images/arr.png"></img></div>
            </section>
            <!-- 图片切换 -->
            <section class="swiper swiper-news">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img
                            src="../../../public/statics/images/Index/news1.jpg"
                        />
                    </div>
                    <div class="swiper-slide">
                        <img
                        src="../../../public/statics/images/Index/news1.jpg"
                        />
                    </div>
                    <div class="swiper-slide">
                        <img
                        src="../../../public/statics/images/Index/news1.jpg"
                        />
                    </div>
                    <div class="swiper-slide">
                        <img
                        src="../../../public/statics/images/Index/news1.jpg"
                        />
                    </div>
                </div>
                <!-- Add Arrows -->
                <div class="swiper-next">
                    <img src="../../../public/statics/images/arr.png">
                </div>
                <div class="swiper-prev">
                    <img src="../../../public/statics/images/arr.png">
                </div>
                <!-- <div class="swiper-pagination"></div> -->
            </section>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeIndex: 0,
            swiper: "",
        };
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {},
    mounted: function () {
        let that = this;
        that.swiper = new Swiper(".swiper-news", {
            navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
            on: {
                slideChangeTransitionStart: function () {
                    // console.log(this.activeIndex);
                    that.activeIndex = this.activeIndex;
                },
                slideChangeTransitionEnd: function () {
                    // console.log(this);
                    // that.activeIndex = this.activeIndex;
                },
            },
        });
        $('.news-pagination').on('click',".pagination-bullet",function(){
            // console.log($(this).index())
            that.swiper.slideTo($(this).index(),1000,true)
        })
    },
    methods: {},
};
</script>

<style scoped>
.page-news {
    width: 100%;
    background: #f0f2f5;
}
.page-news .container {
    padding-left: 47px;
    display: flex;
    position: relative;
}
.page-news .container .info {
    flex: 1;
    position: relative;
    padding-top: 64px;
}
.page-news .container .info .title {
    color: #e22f24;
    font-size: 16px;
    position: relative;
}
.page-news .container .info .new-title{
    color: #333333;
    font-size: 40px;
    font-weight: normal;
    padding-right: 47px;
    margin: 25px 0;
}
.info .btn-more {
    width: 118px;
    height: 44px;
    background: #1677FF;
    font-size: 14px;
    font-family: PingFangSC;
    color: #ffffff;
    margin-top: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.info .btn-more img{
    margin-left: 15px;
}
.page-news .container .info .new-desc{
    color: #333333;
    font-size: 14px;
    padding-right: 47px;
}
.page-news .container .info .title::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -6px;
    width: 32px;
    height: 2px;
    background: #e22f24;
}
.page-news .news-pagination {
    position: absolute;
    top: 45px;
    width: 100%;
    text-align: right;
    height: 16px;
    padding-right: 47px;
}
.page-news .news-pagination .pagination-bullet {
    width: var(
        --swiper-pagination-bullet-width,
        var(--swiper-pagination-bullet-size, 8px)
    );
    height: var(
        --swiper-pagination-bullet-height,
        var(--swiper-pagination-bullet-size, 8px)
    );
    display: inline-block;
    border-radius: 50%;

    background: #e22f24;
    opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
}
.page-news .news-pagination .pagination-bullet.pagination-bullet-active {
    opacity: var(--swiper-pagination-bullet-opacity, 1);
    background: #e22f24;
}
.swiper {
    width: 709px;
    height: 466px;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    position: relative;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.page-news .swiper-prev{
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 10;
    top: 50%;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.page-news .swiper-prev img{
    transform: rotateZ(180deg);
}
.page-news .swiper-next{
    width: 44px;
    height: 44px;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    z-index: 10;
    top: 50%;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.page-news .swiper-prev:hover,.page-news .swiper-next:hover{
    transition:all 0.3s ease-out;
    background: #1677FF;
}
</style>
